import { CnTimeline, Timeline as UITimeLine } from '@cainiaofe/cn-ui';
import { executeFunction, isArrayNotEmpty } from '@/common/util/util';
import { DisplayPosition } from '@/common/manager/position/display-position';
const RealTimeLine = CnTimeline || UITimeLine;
const TimelineItem = CnTimeline?.Item || UITimeLine.Item;
export const config = {
    position: [DisplayPosition.form, DisplayPosition.formDialog],
    componentName: 'TimeLine',
    formItemBeforeHandler: (formItem, config) => {
        const { state } = config || {};
        if (formItem) {
            const componentProps = formItem?.['x-component-props'];
            if (componentProps) {
                componentProps.getRequestParams = () => {
                    return {
                        state,
                    };
                };
            }
        }
    },
    formComponent: (props) => {
        const { value, __bizExtendConfig__ = {}, getRequestParams, _customRenderContent, } = props || {};
        if (isArrayNotEmpty(value)) {
            let _params = {};
            if (typeof getRequestParams === 'function') {
                _params = getRequestParams();
            }
            return (<RealTimeLine {...(__bizExtendConfig__ ?? {})}>
          {value.map((item) => {
                    const { title, time, state, content, ...rest } = item || {};
                    let realContent = content;
                    if (typeof _customRenderContent === 'function') {
                        const temp = executeFunction(_customRenderContent, item, _params?.state);
                        if (temp) {
                            realContent = temp;
                        }
                    }
                    return (<TimelineItem {...rest} content={realContent} title={title} time={time} state={state}/>);
                })}
        </RealTimeLine>);
        }
        return null;
    },
};
